import React from 'react'
import { CustomAlertRules } from '../components/ui/custom-alert-rules'
import { CustomOverlaySidebar } from '../components/ui/custom-overlay-sidebar'
import { ArrowLeft, Settings, Menu, LogOut } from 'lucide-react'
import { useLogout } from '../hooks/useLogout'
import { useSidebar } from '../hooks/useSidebar'

export default function CustomAlertRulesPage() {
  const { sidebarOpen, openSidebar, closeSidebar } = useSidebar()
  const handleLogout = useLogout()

  return (
    <div style={{ backgroundColor: '#0f0f0f', minHeight: '100vh', color: '#e2e8f0' }}>
      <CustomOverlaySidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Header */}
      <div style={{
        backgroundColor: '#0d1117',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        padding: '0 24px',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 40,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={openSidebar}
            style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: '4px' }}
          >
            <Menu size={20} />
          </button>

          <button
            onClick={() => window.location.href = '/'}
            style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px',
              color: '#94a3b8',
              cursor: 'pointer',
              padding: '6px 12px',
              fontSize: '13px',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLButtonElement).style.color = '#e2e8f0'
              ;(e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,255,255,0.2)'
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLButtonElement).style.color = '#94a3b8'
              ;(e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,255,255,0.1)'
            }}
          >
            <ArrowLeft size={14} />
            Dashboard
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Settings size={18} style={{ color: '#00A9A7' }} />
            <span style={{ fontWeight: 600, fontSize: '16px', color: '#e2e8f0' }}>
              Custom Alert Rules
            </span>
          </div>
        </div>

        <button
          onClick={handleLogout}
          style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            background: 'none', border: 'none',
            color: '#94a3b8', cursor: 'pointer',
            fontSize: '13px',
          }}
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>

      {/* Content */}
      <div style={{ padding: '24px' }}>
        <CustomAlertRules />
      </div>
    </div>
  )
}
